export default __webpack_public_path__ + "static/media/background.0beec766.mp4";